import { render } from "./Valeurs2.vue?vue&type=template&id=c7376ad6&scoped=true"
import script from "./Valeurs2.vue?vue&type=script&lang=js"
export * from "./Valeurs2.vue?vue&type=script&lang=js"

import "./Valeurs2.vue?vue&type=style&index=0&id=c7376ad6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7376ad6"]])

export default __exports__